<template>
    <div v-if="data" class="row cursor-pointer" @click="openBlogArticlePage">

        <!-- LEFT SIDE -->
        <div class="col-lg-6">
            <img
                v-if="data.image"
                :src="data.image"
                :alt="data.title"
            >
        </div>

        <!-- RIGHT SIDE -->
        <div class="col-lg-6 blog-content">

            <div class="fl-j-sb fl-x mb-2 date-row">
                <p
                    v-if="data.author_name"
                    class="font-manrope-medium fs--1 text-2 mb-1 mr-1 author-name"
                >
                    {{ data.author_name }}
                </p>

                <p
                    v-if="data.create_date"
                    class="font-manrope-medium fs--1 text-2 ml-2 blog-date"
                >
                    {{ data.create_date }}
                </p>
            </div>

            <div class="content-area">
                <h2
                    v-if="data.title"
                    class="font-manrope-medium text-primary fs-lg-2 bb-black fl-j-c fs-lg-1"
                >
                    {{ data.title }}
                </h2>

                <p
                    v-if="data.title_description"
                    class="font-manrope-medium text-2 fs-lg--1 fl-j-c mb-2"
                >
                    {{ data.title_description }}
                </p>
            </div>

            <div class="button-area fl-x">
                <p
                    v-if="data.category"
                    class="p-btn font-manrope-medium mr-2"
                >
                    {{ data.category }}
                </p>

                <btn
                    design="basic-a"
                    border-radius="4"
                    size="sm"
                    class="font-manrope-medium px-4 mb-3"
                >
                    view
                </btn>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'BlogLastMile',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    methods: {
        openBlogArticlePage () {
            this.$router.push('/blog-article-article/' + this.data.id + '/details/');
        }
    }

};
</script>

<style scoped>
img {
    width: 100%;
    height: 100%;
}

.blog-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.content-area {
    flex: 1;
}

.button-area {
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 10px;
}

h2 {
    overflow-wrap: anywhere;
    word-break: break-word;
}

p {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.p-btn {
    border: 1px solid black;
    border-radius: 16px;
    font-size: 12px;
    color: #3D3F40;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 4px;
    padding-bottom: 5px;
}

@media (max-width: 765px) {
    img {
        /*width: 80%;*/
    }
}
.date-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.author-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;   /* Maximum 2 lines */
    -webkit-box-orient: vertical;
    word-break: break-word;
}

.blog-date {
    flex: 0 0 auto;
    white-space: nowrap;
    margin-left: auto;
}
</style>
